module.exports = __webpack_public_path__ + "static/img/credencial-1.ad4c807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credencial-1.png
// module id = kS0E
// module chunks = 1